import { DataBean } from "../DataBean";

export class QualityInspectionItem extends DataBean {

  public async getQualityInspectionItemCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInspectionItemCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityInspectionItemRender(page: number, rows: number, properties: any, FromDate:any, UptoDate: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityInspectionItemRender_Number_Number_java.util.Map_java.util.Date_java.util.Date",
      [page, rows, properties, FromDate, UptoDate]
    );
  }

  public async deleteQualityInspectionItem(idqualityinspectionitem: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInspectionItem_Number", [idqualityinspectionitem]);
  }

  public async updateQualityInspectionItem(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInspectionItem_updateQualityInspectionItem_com.orange.finance.processcontract.bean.QualityInspectionItem",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInspectionItem",
        },
      ]
    );
  }
}
